import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSeason } from '../context/SeasonContext';
import api from '../api';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';
import styles from '../styles/Header.module.css';

const Header = () => {
  const { user, logout } = useAuth();
  const { adminOverride, effectiveSeason } = useSeason();
  const navigate = useNavigate();
  const [showPlayoffTab, setShowPlayoffTab] = useState(false);

  useEffect(() => {
    const checkPlayoff = async () => {
      if (user) {
        try {
          const response = await api.getPlayoffStatus(effectiveSeason);
          // Show tab for active or completed playoffs (so users can see results)
          setShowPlayoffTab(response.data.exists && (response.data.playoff.status === 'active' || response.data.playoff.status === 'completed'));
        } catch (err) {
          setShowPlayoffTab(false);
        }
      }
    };
    checkPlayoff();
    // Check periodically
    const interval = setInterval(checkPlayoff, 30000); // Every 30 seconds
    return () => clearInterval(interval);
  }, [user, effectiveSeason]);

  const isDevEnvironment = window.location.hostname === 'dev.lotwleague.com';

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className={`${styles.header} ${styles.stickyHeader}`}>
      {/* Dev Environment Banner */}
      {isDevEnvironment && (
        <div className={styles.devBanner}>
          DEV ENVIRONMENT
        </div>
      )}

      {/* Admin Override Indicator */}
      {adminOverride && (
        <div className={styles.adminOverrideBanner}>
          {adminOverride} Archive
        </div>
      )}

      <div className={styles.headerContent}>
        <nav className={styles.nav}>
          <ul className={styles.navList}>
            <li><Link to="/">Home</Link></li>
            {user && <li><Link to="/weekly-picks">Weekly Picks</Link></li>}
            {user && <li><Link to="/leaderboard">League Stats</Link></li>}
            {user && showPlayoffTab && <li><Link to="/playoff">🏆 League Playoff</Link></li>}
            {user?.role === 'admin' && <li><Link to="/admin">Admin Dashboard</Link></li>}
          </ul>
        </nav>

        {/* User Section */}
        {user && (
          <div className={styles.userSection}>
            <span className={styles.userGreeting}>Hello, {user.username}</span>
            <Link to="/user-settings" className={styles.settingsButton}>
              <SettingsSharpIcon className={styles.settingsIcon} />
            </Link>
            <button onClick={handleLogout} className={styles.logoutButton}>
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
